import { useQuery } from "react-query";

import { getAttachmentMetaById } from "../service";

export const useAttachmentMetaByIdQuery = (attachmentId?: number | null) => {
  const { data } = useQuery(
    ["attachment-by-id", attachmentId],
    async () => await getAttachmentMetaById({ attachmentId: attachmentId! }),
    {
      enabled: Boolean(attachmentId),
      suspense: false,
    },
  );

  return {
    data,
  };
};
